// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".commutably {\n  --submit-button-animation-duration-ms: 1000;\n}\n", "",{"version":3,"sources":["webpack://./src/theme/components/SubmitButton.css"],"names":[],"mappings":"AAAA;EACE,2CAA2C;AAC7C","sourcesContent":[".commutably {\n  --submit-button-animation-duration-ms: 1000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
